<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <!-- Search + Add -->
            <div class="col-12 col-lg-4 mb-2 mb-lg-0 d-flex gap-2">
               <input v-model="search" type="text" class="form-control form-control-sm"
                  placeholder="&#xF002; Search by title or URL..."
                  style="border-radius:8px; height: 40px; font-size: 14px; font-family: 'Roboto', sans-serif, 'Font Awesome 6 Free'; font-weight: 900;"
                  @keyup="onSearch()" />
            </div>

            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="fw-bold btn btn-sm text-light"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem; white-space: nowrap; background: #00A0C1;"
                  @click="showAddModal = true">
                  <i class="fa-solid fa-plus me-1"></i> Add Password Website
               </button>
            </div>

            <!-- Filters + Pagination -->
            <div class="col-12 col-lg d-flex flex-wrap justify-content-lg-end align-items-center">

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Filter:</span>
                  <select v-model="filterStatusBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="f in filterStatus" :value="f.value" :key="f.value">{{ f.text }}</option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Sort by:</span>
                  <select v-model="sortBy" class="form-select shadow-none filterOptions bordered-select">
                     <option v-for="s in sortByList" :value="s.value" :key="s.value">{{ s.text }}</option>
                  </select>
               </div>

               <div class="d-flex align-items-center me-3 mb-2 mb-md-0">
                  <span class="p-2 filterTitle">Rows per page:</span>
                  <select v-model="pagination.pageSize"
                     class="form-select form-select-sm shadow-none filterOptions bordered-select" style="width: auto;">
                     <option v-for="row in rowsPerPageList" :value="row.value" :key="row.value">{{ row.text }}</option>
                  </select>
               </div>

               <div class="pagination" v-if="pagination.totalItems > 0">
                  <button @click="previousPage()" :disabled="pagination.page == 1" class="pagination-arrow">
                     <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="pagination-label">
                     <strong>{{ paginationLabel }}</strong> of {{ pagination.totalItems }}
                  </span>
                  <button @click="nextPage()"
                     :disabled="pagination.page == pagination.totalPages || pagination.totalItems == 0"
                     class="pagination-arrow">
                     <i class="fa fa-chevron-right"></i>
                  </button>
               </div>

            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th scope="col" style="width: 295px;">Page Title</th>
                     <th scope="col">URL</th>
                     <th scope="col" style="width: 110px;">Status</th>
                     <th scope="col" style="width: 100px;">Actions</th>
                  </tr>
               </thead>

               <tbody v-if="pagination.totalItems <= 0">
                  <tr>
                     <td colspan="4">No records to display.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(pw, index) in passwordWebsites" :key="index">
                     <td :title="pw.page_title">
                        <span class="title-text">{{ truncateText(pw.page_title, 40) || '—' }}</span>
                     </td>
                     <td :title="pw.url" style="font-family: monospace; font-size: 12px;">
                        {{ truncateText(trimQuestionMark(pw.url), 80) }}
                     </td>
                     <td>
                        <span class="status-pill" :class="pw.is_denied == 1 ? 'status-denied' : 'status-allowed'">
                           <i :class="pw.is_denied == 1 ? 'fa-solid fa-ban' : 'fa-solid fa-circle-check'" class="me-1"></i>
                           {{ pw.is_denied == 1 ? 'Denied' : 'Allowed' }}
                        </span>
                     </td>
                     <td>
                        <div class="d-flex gap-2">
                           <button v-if="pw.is_denied == 1" type="button"
                              class="ms-action-btn ms-action-btn--success"
                              title="Allow this website"
                              @click="updatePasswordWebsite(pw.id, 0)">
                              <i class="fa-solid fa-check"></i>
                           </button>
                           <button v-if="pw.is_denied == 0" type="button"
                              class="ms-action-btn ms-action-btn--warning"
                              title="Deny this website"
                              @click="updatePasswordWebsite(pw.id, 1)">
                              <i class="fa-solid fa-ban"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--delete"
                              title="Delete"
                              @click="confirmDelete(pw)">
                              <i class="fa-solid fa-xmark"></i>
                           </button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>

      </div>
   </div>

   <!-- Add Modal -->
   <div class="modal-backdrop-custom" v-if="showAddModal" @click.self="showAddModal = false">
      <div class="modal-content-custom">
         <button @click="closeAddModal()" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-key me-2" style="color: #00A0C1;"></i>
            Add Password Website
         </h5>
         <hr>
         <div class="modal-body-custom">
            <label class="filter-label">Page Title</label>
            <input type="text" class="form-control form-control-sm mb-3"
               style="border-radius: 8px;"
               placeholder="e.g. Company Login Page"
               v-model="inputTitle">

            <label class="filter-label">URL</label>
            <input type="text" class="form-control form-control-sm mb-3"
               style="border-radius: 8px;"
               placeholder="e.g. https://login.example.com"
               v-model="inputUrl" v-on:keyup.enter="addPasswordWebsite()">

            <label class="filter-label">Status</label>
            <div class="d-flex gap-2">
               <button type="button" class="btn btn-sm flex-fill"
                  :class="inputStatus === 0 ? 'status-btn-active-allow' : 'status-btn-inactive'"
                  @click="inputStatus = 0">
                  <i class="fa-solid fa-circle-check me-1"></i> Allowed
               </button>
               <button type="button" class="btn btn-sm flex-fill"
                  :class="inputStatus === 1 ? 'status-btn-active-deny' : 'status-btn-inactive'"
                  @click="inputStatus = 1">
                  <i class="fa-solid fa-ban me-1"></i> Denied
               </button>
            </div>
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="closeAddModal()">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #00A0C1; border-radius: 8px;"
               @click="addPasswordWebsite()">
               <i class="fa-solid fa-plus me-1"></i> Add
            </button>
         </div>
      </div>
   </div>

   <!-- Delete Confirm Modal -->
   <div class="modal-backdrop-custom" v-if="showDeleteModal" @click.self="showDeleteModal = false">
      <div class="modal-content-custom">
         <button @click="showDeleteModal = false" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-solid fa-xmark me-2" style="color: #c62828;"></i>
            Delete Password Website
         </h5>
         <hr>
         <div class="modal-body-custom">
            <p>Are you sure you want to delete this password website?</p>
            <div class="site-display">{{ deleteWebsiteName }}</div>
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="showDeleteModal = false">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #c62828; border-radius: 8px;"
               @click="deletePasswordWebsite()">
               <i class="fa-solid fa-xmark me-1"></i> Delete
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import { debounce, extractErrorMessage } from '@/plugins/helper.js'

export default {
   data() {
      return {
         showAddModal: false,
         showDeleteModal: false,
         deleteID: 0,
         deleteWebsiteName: '',
         search: "",
         passwordWebsites: [],
         inputTitle: "",
         inputUrl: "",
         inputStatus: 0,
         debounceFn: null,
         paginationData: {},
         pagination: {
            pageSize: 50, page: 1, totalItems: 0, totalPages: 1,
         },
         rowsPerPageList: [
            { text: "50", value: 50 },
            { text: "75", value: 75 },
            { text: "100", value: 100 },
         ],
         filterStatus: [
            { text: "Allowed", value: 0 },
            { text: "Denied", value: 1 },
            { text: "Both", value: 2 },
         ],
         filterStatusBy: 2,
         sortByList: [
            { text: "Date: Newest", value: "dateCreated_desc" },
            { text: "Date: Oldest", value: "dateCreated_asc" },
         ],
         sortBy: "dateCreated_desc",
         sorting: { field: "name", order: "desc" },
      }
   },

   computed: {
      paginationLabel() {
         var start = Math.min((this.pagination.page - 1) * this.pagination.pageSize + 1, this.pagination.totalItems)
         var end = Math.min((this.pagination.page * this.pagination.pageSize), this.pagination.totalItems)
         return start + " - " + end
      },
      currentPage() { return this.pagination.page },
      rowsPerPage() { return this.pagination.pageSize },
      sortItems() { return this.sortBy },
      filterByStatus() { return this.filterStatusBy },
   },

   watch: {
      currentPage() { this.getPasswordWebsites() },
      filterByStatus() { this.getPasswordWebsites() },
      rowsPerPage() { this.pagination.page = 1; this.getPasswordWebsites() },
      sortItems() {
         if (this.sortBy.includes("_")) {
            let sort = this.sortBy.split("_")
            this.sorting.field = sort[0]
            this.sorting.order = sort[1]
         } else {
            this.sorting.field = this.sortBy
            this.sorting.order = ""
         }
         this.getPasswordWebsites()
      },
   },

   created() {
      this.debounceFn = debounce(() => this.getPasswordWebsites(), 500)
      this.getPasswordWebsites()
   },

   methods: {
      truncateText(text, limit) {
         if (!text) return '';
         return text.length <= limit ? text : text.slice(0, limit) + '...';
      },

      trimQuestionMark(text) {
         if (!text) return '';
         let index = text.indexOf('?');
         return index > 0 ? text.substring(0, index) : text;
      },

      isValidHttpUrl(string) {
         try { let url = new URL(string); return url.protocol === "http:" || url.protocol === "https:"; }
         catch (_) { return false; }
      },

      closeAddModal() {
         this.showAddModal = false
         this.inputTitle = ""; this.inputUrl = ""; this.inputStatus = 0;
      },

      confirmDelete(pw) {
         this.deleteID = pw.id
         this.deleteWebsiteName = pw.page_title || pw.url
         this.showDeleteModal = true
      },

      previousPage() { this.pagination.page > 1 ? this.pagination.page -= 1 : '' },
      nextPage() { this.pagination.totalPages > this.pagination.page ? this.pagination.page += 1 : '' },
      onSearch() { this.pagination.page = 1; this.debounceFn() },

      async addPasswordWebsite() {
         try {
            if (!this.inputUrl || !this.isValidHttpUrl(this.inputUrl)) {
               this.$toast.error("Please provide a valid URL (include https://).")
               return
            }
            if (!this.inputTitle) {
               this.$toast.error("Please provide a page title.")
               return
            }
            const payload = { url: this.inputUrl, page_title: this.inputTitle, is_denied: this.inputStatus }
            const resp = await this.$axios.post("admin-controls/create-password-website", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getPasswordWebsites()
            }
            this.closeAddModal()
         } catch (error) {
            console.log(error)
            if (error.response && error.response.status === 422) {
               this.$toast.error(extractErrorMessage(error, "This website URL is already in the Password Websites list."))
            } else {
               this.$toast.error(extractErrorMessage(error, "Failed to add password website."))
            }
            this.closeAddModal()
         }
      },

      async updatePasswordWebsite(id, val) {
         try {
            const payload = { id: id, is_denied: val }
            const resp = await this.$axios.post("admin-controls/update-password-website-status", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getPasswordWebsites()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to update password website status."))
         }
      },

      async deletePasswordWebsite() {
         try {
            const resp = await this.$axios.delete("admin-controls/remove-password-website/" + this.deleteID)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message)
               this.getPasswordWebsites()
            }
            this.deleteID = 0; this.deleteWebsiteName = '';
            this.showDeleteModal = false
         } catch (error) {
            console.log(error)
            this.$toast.error(extractErrorMessage(error, "Failed to remove password website."))
            this.deleteID = 0; this.showDeleteModal = false
         }
      },

      async getPasswordWebsites() {
         let apiPath = "admin-controls/get-password-websites?page_size=" + this.pagination.pageSize + "&page=" + this.pagination.page + "&status=" + this.filterStatusBy

         if (this.sorting.order != "") {
            apiPath += "&order_by=" + this.sorting.order
         }
         if (this.search !== "" || this.search !== null) {
            apiPath += "&keyword=" + this.search
         }

         await this.$axios.get(apiPath)
            .then((response) => {
               if (response.data.password_websites === "No Record Found")
                  this.passwordWebsites = []
               else {
                  this.passwordWebsites = response.data.password_websites
               }
               this.paginationData = response.data.pagination
               this.pagination.totalItems = this.paginationData.total_count
               this.pagination.totalPages = Math.ceil(this.paginationData.total_count / this.pagination.pageSize)
            })
            .catch((error) => {
               this.$toast.error(extractErrorMessage(error, "Failed to load password websites."))
            })
      },
   },
}
</script>

<style scoped>
.card { border: none; }

.title-text { font-size: 13px; font-weight: 500; color: #435666; }

/* Status pills */
.status-pill {
   padding: 4px 10px;
   border-radius: 6px;
   font-size: 11px;
   font-weight: 600;
   display: inline-flex;
   align-items: center;
   white-space: nowrap;
}
.status-allowed { background: #e6f9ee; color: #00873c; }
.status-denied { background: #fde8ea; color: #c62828; }

/* Action buttons */
.btn-action {
   width: 30px; height: 30px; padding: 0;
   border-radius: 6px;
   display: inline-flex; align-items: center; justify-content: center;
   font-size: 12px; transition: all 0.15s ease;
}
.btn-action-allow { border: 1px solid #00873c; color: #00873c; background: #fff; }
.btn-action-allow:hover { background: #00873c; color: #fff; }
.btn-action-deny { border: 1px solid #00A0C1; color: #00A0C1; background: #fff; }
.btn-action-deny:hover { background: #00A0C1; color: #fff; }
.btn-action-delete { border: 1px solid #c62828; color: #c62828; background: #fff; }
.btn-action-delete:hover { background: #c62828; color: #fff; }

/* Status toggle buttons in modal */
.status-btn-active-allow {
   background: #e6f9ee; color: #00873c; border: 2px solid #00873c;
   border-radius: 8px; font-weight: 600;
}
.status-btn-active-deny {
   background: #fde8ea; color: #c62828; border: 2px solid #c62828;
   border-radius: 8px; font-weight: 600;
}
.status-btn-inactive {
   background: #f8f9fa; color: #6c757d; border: 1px solid #dee2e6;
   border-radius: 8px; font-weight: 500;
}
.status-btn-inactive:hover { background: #e9ecef; }

/* Site display in delete modal */
.site-display {
   font-family: monospace; font-size: 13px;
   background: #fde8ea; padding: 8px 12px;
   border-radius: 8px; color: #c62828;
   word-break: break-all;
}

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 480px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.filter-label {
   font-size: 11px; font-weight: 600; color: #6c757d;
   text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 4px;
   display: block;
}
.modal-footer-custom { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }
</style>